
import {
    KinesisVideoClient,
    GetSignalingChannelEndpointCommand,
    ChannelProtocol,
} from "@aws-sdk/client-kinesis-video";
import { Role } from "amazon-kinesis-video-streams-webrtc";
import { IAwsCredentials } from "../types/kinesis.js";


export class KinesisVideoService {
    private client: KinesisVideoClient;


    constructor(config: IAwsCredentials) {
        this.client = new KinesisVideoClient(config);
    }


    async getSignallingChannelEndpoint(
        channelARN: string,
        protocols: ChannelProtocol[] = ["WSS", "HTTPS"],
    ) {
        try {
            
            const command = new GetSignalingChannelEndpointCommand({
                ChannelARN: channelARN,
                SingleMasterChannelEndpointConfiguration: {
                    Protocols: protocols,
                    Role: Role.VIEWER,
                },
            });


            const response = await this.client.send(command);
            return response;
        } catch (error) {
            // notification.error({
            //     message: "Error",
            //     description: "Error getting signaling channel endpoint:",
            // });
            console.error("Error getting signaling channel endpoint:", error);
            throw error;
        }
    }
}
